import { make } from 'vuex-pathify'

const state = {
  user: {}
}

const mutations = make.mutations(state)

export const store = {
  namespaced: true,
  state,
  mutations
}
